const twitterWidgetJs = 'https://platform.twitter.com/widgets.js'
export default twitterWidgetJs
